import { type ComponentProps, useMemo } from 'react';
import { type ViewStyle } from 'react-native';
import { useStyle } from 'react-native-style-utilities';
import { type FlashList } from '@shopify/flash-list';

// ─────────────────────────────────────────────────────────────────────────────

export const useRailOffsetStyles: UseRailOffsetStyles = (outerOffset) => {
  const containerStyle = useStyle(
    () => ({ paddingHorizontal: Math.abs(outerOffset) }),
    [outerOffset],
  );
  const railStyle = useStyle(
    () => ({ marginHorizontal: outerOffset }),
    [outerOffset],
  );

  return useMemo(
    () => ({ containerStyle, railStyle }),
    [containerStyle, railStyle],
  );
};

// ─────────────────────────────────────────────────────────────────────────────

type UseRailOffsetStyles = (outerOffset: number) => {
  containerStyle: NonNullable<
    ComponentProps<typeof FlashList>['contentContainerStyle']
  >;
  railStyle: ViewStyle;
};
